import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Guid, IGroupDto, IUserDto } from "moo-shared";
import { Observable } from "rxjs";
import { EnvironmentService } from "../environment.service";
import { IpTokenService } from "./iptoken.service";

const apiUrlPattern = "https://resource@env.moo.nl/resource/api/v1";
@Injectable()
export class ResourceApiService {
  apiBasePath = "";

  constructor(
    private environmentService: EnvironmentService,
    private iptokenService: IpTokenService,
    private httpClient: HttpClient) {
    this.getResourceApiUrl();
  }

  private addAuthorizationHeader(headers: HttpHeaders = new HttpHeaders({})): HttpHeaders {
    return headers.append("Authorization", `Bearer ${this.iptokenService.currentToken}`);
  }

  private getResourceApiUrl() {
    const env = this.environmentService.getEnvironmentTag();
    this.apiBasePath = apiUrlPattern.replace("@env", env);
  }

  getOrganisationStudentsGroups(organisationKey: Guid): Observable<IGroupDto[]> {
    const url = `${this.apiBasePath}/organisations/${organisationKey}/groups/type/student`;
    return this.httpClient.get<IGroupDto[]>(url, {
      headers: this.addAuthorizationHeader(),
      params: {
        select: "Name"
      }
    });
  }

  getGroupPictureUrl(key: string): string {
    return `${this.apiBasePath}/groups/${key}/AccountPngPicture`;
  }

  getUserPicture(key: string): Observable<Blob> {
    const url = `${this.apiBasePath}/users/${key}/AccountPicture`;
    return this.httpClient.get(url, {
      headers: this.addAuthorizationHeader().append("Accept", "image/png"),
      responseType: "blob"
    });
  }

  getGroupDetails(groupKey: string): Observable<IGroupDto> {
    const url = `${this.apiBasePath}/groups/${groupKey}`;
    return this.httpClient.get<IGroupDto>(url, {
      headers: this.addAuthorizationHeader(),
      params: {
        select: "Name"
      }
    });
  }

  getGroupStudents(groupKey: string): Observable<IUserDto[]> {
    const url = `${this.apiBasePath}/users/groups/${groupKey}/type/Student`;
    return this.httpClient.get<IUserDto[]>(url, {
      headers: this.addAuthorizationHeader(),
      params: {
        select: "Name,FirstName,MiddleName,LastName,LoginName",
      }
    });
  }
}
